module.exports = __webpack_public_path__ + "public/SiteIcons/Down_Arrow_3_@2x.png?df328d53";